// Arbre React totalement séparé de l'app authentifiée (voir src/index.js) : aucun Auth0,
// aucun WiloutContext/RolesContext, aucune Sidebar. Monté uniquement pour les chemins
// /accreditation-config et /accreditation-form/:token.
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import accreditationTheme from './theme';
import AccreditationConfigApp from './AccreditationConfigApp';
import AccreditationPublicFormPage from './AccreditationPublicFormPage';
import AccreditationStatusPage from './AccreditationStatusPage';
import PublicSessionExportPage from './PublicSessionExportPage';
import RefundBankDetailsPage from './RefundBankDetailsPage';

const PublicAccreditationApp = () => (
  <ThemeProvider theme={accreditationTheme}>
    <CssBaseline />
    <Router>
      <Routes>
        <Route path="/accreditation-config" element={<AccreditationConfigApp />} />
        <Route path="/accreditation-form/:token" element={<AccreditationPublicFormPage />} />
        <Route path="/accreditation-status/:token" element={<AccreditationStatusPage />} />
        <Route path="/export-seances/:token" element={<PublicSessionExportPage />} />
        <Route path="/remboursement/:token" element={<RefundBankDetailsPage />} />
      </Routes>
    </Router>
  </ThemeProvider>
);

export default PublicAccreditationApp;
